import { render, staticRenderFns } from "./EbookList.vue?vue&type=template&id=cea5fd82&scoped=true&"
import script from "./EbookList.vue?vue&type=script&lang=js&"
export * from "./EbookList.vue?vue&type=script&lang=js&"
import style0 from "./EbookList.vue?vue&type=style&index=0&id=cea5fd82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea5fd82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer})
